import { DeleteOutlined, EditOutlined, ShopOutlined, TeamOutlined } from '@ant-design/icons'
import { Button, Card, Checkbox, Col, DatePicker, Form, Input, InputNumber, Modal, Popconfirm, Row, Select, Space, Table, Tag, Tooltip } from 'antd'
import TextArea from 'antd/lib/input/TextArea';
import React, { useEffect, useState } from 'react'
import { useStoreActions, useStoreState } from '../../../store/hooks/easyPeasy'
import { SelectPartner } from '../../select/SelectIPartner'
import { SelectIPartnerForIsp } from '../../select/SelectIPartnerForIsp';
import { SelectISPPackageSDL } from '../../select/SelectISPPackageSDL';
import { SelectMonth } from '../../select/SelectMonth';
import { SelectYear } from '../../select/SelectYear';

export default function IspPackageSDLCreate(props) {

    const check = useStoreState(state => state.isp.check);
    const ispClientInfoListForSDL = useStoreState(state => state.isp.ispClientInfoListForSDL);
    const fetchispClientInfoListForSDL = useStoreActions(state => state.isp.fetchispClientInfoListForSDL);
    //  const saveIspPackageInfo = useStoreActions(state => state.isp.saveIspPackageInfo);
    const updateIspClientInfoSDL = useStoreActions(state => state.isp.updateIspClientInfoSDL);
    const fetchpartnerListForIsp = useStoreActions((state) => state.partner.fetchpartnerListForIsp);

    const [form] = Form.useForm();
    const [formUpdate] = Form.useForm();

    const onFinish = (values: any) => {
        fetchispClientInfoListForSDL(values.pip.value)
        //form.resetFields();
        setfilterTable(null);
        setsearchv('')
    };

    useEffect(() => {
        fetchpartnerListForIsp("ISP");
    },[])

    const onFinishUpdate = (values: any) => {

        let postData = {
            "clientCustomId": values.clientCustomId,
            "clientId": row,
            "clientName": values.client_name,
            "clientStatus": values.clientStatus ? 1 : 0,
            "mailingAddress": values.address,
            "partnerId": partnerId.value,
            "billingMonth": values.billingMonth,
            "billingYear": values.billingYear,
            "packageId": ispPackage,
            "mobileNo": values.mobile_number
        }

        updateIspClientInfoSDL(postData)
        setIsModalVisible(false);
        fetchispClientInfoListForSDL(partnerId.value)
        formUpdate.resetFields();

    };

    

    useEffect(() => {
        setPageTitle();
    }, []);

    // useEffect(() => {
    //     fetchispClientInfoListForSDL();
    // }, [check])


    const setPageTitle = () => {
        var pageTitleEle = document.getElementById('pageTitle');
        var pageTitle = 'ISP'
        return pageTitleEle ? pageTitleEle.innerHTML = pageTitle : ''
    }

    const [row, setRow] = useState<any>();
    const columns = [

        {
            title: 'ID',
            dataIndex: 'clientCustomId',
            key: 'clientCustomId',

        },
        {
            title: 'Client Name',
            dataIndex: 'clientName',
            key: 'clientName',

        },
        {
            title: 'Mobile No',
            dataIndex: 'mobileNo',
            key: 'mobileNo',

        },
        {
            title: 'Mailing Address',
            dataIndex: 'mailingAddress',
            key: 'mailingAddress',

        },
        {
            title: 'Package Name',
            dataIndex: 'packageName',
            key: 'packageName',

        },
        {
            title: 'Package Price',
            dataIndex: 'packagePrice',
            key: 'packagePrice',

        },
        {
            title: 'Status',
            render: (text: any, record: any, index) => (
                <Space size="middle">
                    {record?.clientStatus === 1 ? <Tag color="success">Enabled</Tag> : <Tag color="error">Disabled</Tag>}

                </Space>
            ),
        },
        {
            title: 'Edit',
            render: (text: any, record: any, index) => (
                <Space size="middle">

                    <Tooltip title="Update Package">
                        <Button type="primary" icon={<EditOutlined />} onClick={() => { showModal(record); }} >Update</Button>
                    </Tooltip>

                </Space>
            ),
        },

    ]

    const [isModalVisible, setIsModalVisible] = useState(false);

    const showModal = (val) => {
        setRow(val?.clientId);
        onchangeIspPackage(val?.packageId);
        formUpdate.setFieldsValue({
            clientCustomId: val?.clientCustomId,
            client_name: val?.clientName,
            mobile_number: val?.mobileNo,
            address: val?.mailingAddress,
            packageId: val?.packageId,
            clientStatus: val?.clientStatus === 1 ? true : false,
        });
        setIsModalVisible(true);

    };

    const handleOk = () => {
        // setIsModalVisible(false);
    };

    const handleCancel = () => {
        setIsModalVisible(false);
    };

    const [partnerId, setPartnerId] = useState<any>(null);

    const onchnagePartner = (val) => {
        setPartnerId(val)
    }

    const [filterTable, setfilterTable] = useState<any>(null);
    const [searchv, setsearchv] = useState<any>('');
    const search = value => {

        const result = ispClientInfoListForSDL.filter(o =>
            Object.keys(o).some(k =>
                String(o[k])
                    .toLowerCase()
                    .includes(value.toLowerCase())
            )
        );
        setfilterTable(result)

    };

    const [ispPackage, onchangeIspPackage] = useState<any>(null);

    console.log("ispClientInfoListForSDL", ispClientInfoListForSDL)

    return (
        <>
            <Card title="ISP Client List" >
            <Form layout="vertical" onFinish={onFinish} id='create-class' form={form} >
                <Row gutter={15} className="p-15">
                    <Col xs={24} sm={24} md={24} lg={6} xl={6}></Col>
                    <Col xs={24} sm={24} md={24} lg={6} xl={6}>

                        <Form.Item
                            name="pip"
                            label="Pip:"
                            className="title-Text"
                            rules={[
                                { required: true, message: "Please select PIP" },
                            ]}
                        >
                            {/* <SelectPartner onChange={(val) => onchnagePartner(val)} selected={partnerId} name="PIP" level={2} /> */}

                            <SelectIPartnerForIsp onChange={(val) => onchnagePartner(val)} selected={partnerId} name="PIP" level={2} />
                        </Form.Item>

                    </Col>

                    <Col xs={24} sm={24} md={24} lg={4} xl={4}>

                        <Space size="small" style={{ marginTop: 30 }} >
                            <Button type="primary" htmlType="submit" >
                                Search
                            </Button>
                        </Space>

                    </Col>

                </Row>
            </Form>
            {ispClientInfoListForSDL?.length > 0 &&
                    <>
                        <span>Total Found: {ispClientInfoListForSDL !== null ? ispClientInfoListForSDL?.length : 0}</span>
                        <Input
                            style={{ margin: "0 0 10px 0", width: 250, float: "right" }}
                            placeholder="Search..."
                            value={searchv}
                            allowClear
                            onChange={(e) => { search(e.target.value); setsearchv(e.target.value) }}
                        />

                        <Table
                            bordered={true}
                            dataSource={searchv === '' ? ispClientInfoListForSDL : filterTable}
                            columns={columns}

                        />
                    </>
            }
            <Modal
                title="Update Client Information"
                visible={isModalVisible}
                onOk={handleOk}
                onCancel={handleCancel}
                width={"40%"}
                okText="Update"
                centered
                cancelButtonProps={{ style: { display: 'none' } }}
                okButtonProps={{ style: { display: 'none' } }}
            >
                <Form layout="vertical" onFinish={onFinishUpdate} id='update-class' form={formUpdate} >
                    <Row gutter={15} >

                        <Col xs={24} sm={24} md={24} lg={12} xl={12}>

                            <Form.Item
                                name="packageId"
                                label="Package Id:"
                                className="title-Text"
                                rules={[
                                    { required: true, message: "Please select package id" },
                                ]}
                            >
                                <SelectISPPackageSDL onChange={(val) => onchangeIspPackage(val)} selected={ispPackage} />
                            </Form.Item>

                        </Col>
                        <Col xs={24} sm={24} md={24} lg={12} xl={12}>

                            <Form.Item
                                name="billingMonth"
                                label="Billing Month:"
                                className="title-Text"
                                rules={[
                                    { required: true, message: "Please select package id" },
                                ]}
                            >

                                <SelectMonth />

                            </Form.Item>

                        </Col>
                        <Col xs={24} sm={24} md={24} lg={12} xl={12}>

                            <Form.Item
                                name="billingYear"
                                label="Billing Year:"
                                className="title-Text"
                                rules={[
                                    { required: true, message: "Please select package id" },
                                ]}
                            >

                                <SelectYear />

                            </Form.Item>

                        </Col>
                        <Col xs={24} sm={24} md={24} lg={12} xl={12}>

                            <Form.Item
                                name="clientCustomId"
                                label="Client Id:"
                                className="title-Text"
                                rules={[
                                    { required: true, message: "Please write client id" },
                                ]}
                            >
                                <Input type="text" placeholder="Client Id"></Input>
                            </Form.Item>

                        </Col>
                        <Col xs={24} sm={24} md={24} lg={12} xl={12}>

                            <Form.Item
                                name="client_name"
                                label="Client Name:"
                                className="title-Text"
                                rules={[
                                    { required: true, message: "Please write client name" },
                                ]}
                            >
                                <Input type="text" placeholder="Client Name"></Input>
                            </Form.Item>

                        </Col>
                        <Col xs={24} sm={24} md={24} lg={12} xl={12}>

                            <Form.Item
                                name="mobile_number"
                                label="Mobile:"
                                className="title-Text"

                                rules={[
                                    { required: true, message: "Please write your number", },
                                ]}
                            >
                                <Input type="text" placeholder="01711....."></Input>
                            </Form.Item>

                        </Col>
                        <Col xs={24} sm={24} md={24} lg={12} xl={12}>

                            <Form.Item
                                name="address"
                                label="Mailing Address:"
                                className="title-Text"

                                rules={[
                                    { required: true, message: "Please write your address", },
                                ]}
                            >
                                <TextArea placeholder="Your Address....."></TextArea>
                            </Form.Item>

                        </Col>

                        <Col xs={24} sm={24} md={24} lg={12} xl={12}>

                            <Form.Item
                                name="clientStatus"
                                label="Client Status:"
                                className="title-Text"
                                valuePropName="checked"
                            >
                                <Checkbox >Check To Enable Client</Checkbox>
                            </Form.Item>

                        </Col>
                        <Col xs={24} sm={24} md={24} lg={12} xl={12}>

                            <Space size="small" style={{ marginTop: 30, float: "right" }} >
                                <Button type="primary" htmlType="submit" >
                                    Update
                                </Button>
                            </Space>

                        </Col>
                    </Row>
                </Form>
            </Modal>
            </Card>
        </>
    )
}
